
export const SAVE_USER_BUILDER_LIST = "SAVE_USER_BUILDER_LIST";
export const GET_USER_BUILDER_LIST = "GET_USER_BUILDER_LIST";